import { useAuthStore } from '@/lib/auth/auth-store';
import { AppLayout } from './app-layout';
import { PublicLayout } from './public-layout';

/**
 * Chrome for the opportunities catalogue, chosen by session.
 *
 * The catalogue is the one surface both audiences share: it must stay reachable
 * with no session at all (a logged-out visitor browsing and being enticed to
 * register), while a signed-in applicant reaching it from the sidebar should not
 * watch their navigation disappear.
 *
 * One URL rather than a public copy and an in-shell copy, because the link is
 * shared — an opportunity URL goes out in emails and messages, and it has to
 * open for whoever follows it, signed in or not.
 *
 * The cost is that a COLD load while signed in paints the public header for as
 * long as the silent auth takes, then swaps. In-app navigation never shows it
 * (status is settled by then). That was worth accepting over duplicating the
 * catalogue and detail routes under two paths, which would have split every
 * inbound link into a right one and a wrong one.
 */
export function CatalogChrome() {
  // `status` is deliberately not consulted: while it is `unknown` there is no
  // user, which is the correct assumption for a public page — the anonymous
  // visitor is the common case here and gets the right chrome immediately.
  const user = useAuthStore((s) => s.user);
  return user ? <AppLayout /> : <PublicLayout />;
}
